// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + {"240":"support","594":"about"}[chunkId] + "." + {"240":"2f985118","594":"380d81db"}[chunkId] + ".js";
};